import { DeviceDetailedHealth } from 'types/Device';

export const generateDetailedHealthData = () => {
    const output: DeviceDetailedHealth = {
        additional: '',
        batteryHist: [],
        battery_err: false,
        battery_status: '',
        dev_type: '',
        device_id: '',
        escalate: false,
        fplmn_banned: false,
        ftt_crit: false,
        fw_rev: '',
        healthy: '',
        hf_prop: 0,
        last_reading: '',
        last_reading_time: 0,
        minVoltage: 0,
        new_loc: false,
        off_prop: 0,
        offline: false,
        offline_dead: false,
        offline_recent: false,
        rate: 0,
        rsrp_eng: '',
        rsrq_eng: '',
        rssi: [],
        sensor_voltage: [],
        signalHist: [],
        telemetry_errors: [],
        temps: [],
        time: [],
        voltage: [],
    };
    return output;
};
